import { useTranslation } from "react-i18next";
import TextField from "@/components/layouts/History/TextField";
import { usePartners } from "@/pages/partners/hooks";
import { toIdList } from "@/entities/history/helpers";
import { logFieldValue } from "@/entities/history/types";
import { map } from "lodash";

interface PartnerNameProps {
  value: logFieldValue;
}

// Serves every partner reference in the log — partners.parent_partner as well as
// partner_id on deals, leads and contracts
const PartnerName: React.FC<PartnerNameProps> = ({ value }) => {
  const { t } = useTranslation();
  const partnerIds = toIdList(value);
  const { entities: partners, isLoading } = usePartners(partnerIds, {
    enabled: partnerIds.length > 0
  });

  if (partnerIds.length === 0) return null;

  const names = map(partners, (partner) => partner?.name)
    .filter(Boolean)
    .join(", ");

  // Ids that resolve to nothing (deleted partner) render the same fallback as
  // the enum branch rather than an empty gap — but not while the lookup is
  // still in flight, or "unknown" flashes before the name arrives
  if (!names) return isLoading ? null : <TextField>{t("unknown")}</TextField>;

  return <TextField>{names}</TextField>;
};

export default PartnerName;
